<div class="content-block" id="container">
  <h2>{{ formatMessage("paperManagement.title") }}</h2>

  <div class="d-flex align-items-center" style="margin-bottom: 1em">
    <div style="margin-right: 0.5rem">
      {{ formatMessage("paperManagement.publisher") }}:
    </div>
    <dx-lookup
      *ngIf="publishers"
      [dataSource]="publishers"
      displayExpr="displayName"
      style="min-width: 300px"
      [value]="selectedPublisher"
      [searchEnabled]="true"
      (onValueChanged)="onPublisherChanged($event)"
    ></dx-lookup>
  </div>

  <dx-data-grid
    *ngIf="selectedPublisher"
    [dataSource]="paperConfigurations"
    [showBorders]="true"
    [columnAutoWidth]="true"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    keyExpr="id"
    class="dx-card wide-card"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowInserting)="onRowInserting($event)"
    (onRowUpdating)="onRowUpdating($event)"
    (onRowRemoving)="onRowRemoving($event)"
  >
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>

    <dxo-paging [pageSize]="15"></dxo-paging>
    <dxo-pager
      [visible]="true"
      [showPageSizeSelector]="true"
      [showInfo]="true"
      [allowedPageSizes]="[15, 30, 50, 'all']"
    ></dxo-pager>

    <dxo-header-filter
      [visible]="true"
      [allowSearch]="true"
      [texts]="{
        emptyValue: formatMessage('user.dataGrid.headerFilter.emptyValue')
      }"
    ></dxo-header-filter>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <!-- batch mode allows editing multiple rows before saving -->
    <dxo-editing
      mode="batch"
      [allowAdding]="true"
      [allowUpdating]="true"
      [allowDeleting]="false"
      [confirmDelete]="true"
      [useIcons]="true"
    ></dxo-editing>

    <dxi-column
      dataField="description"
      [caption]="formatMessage('paperManagement.description')"
      sortOrder="asc"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="ppi"
      [caption]="formatMessage('paperManagement.ppi')"
      dataType="number"
    ></dxi-column>

    <dxi-column
      dataField="rollWidth"
      [caption]="formatMessage('paperManagement.rollWidth')"
      dataType="number"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="basisWeight"
      [caption]="formatMessage('paperManagement.basisWeight')"
      dataType="number"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="paperCoat"
      [caption]="formatMessage('paperManagement.paperCoat')"
    ></dxi-column>

    <dxi-column
      dataField="stock"
      [caption]="formatMessage('paperManagement.stock')"
    ></dxi-column>

    <dxi-column
      dataField="color"
      [caption]="formatMessage('paperManagement.color')"
    ></dxi-column>

    <dxi-column
      dataField="colorShort"
      [caption]="formatMessage('paperManagement.colorShort')"
    ></dxi-column>

    <dxi-column
      dataField="customerFurnished"
      [caption]="formatMessage('paperManagement.customerFurnished')"
      dataType="boolean"
    ></dxi-column>

    <dxi-column
      dataField="enabled"
      [caption]="formatMessage('paperManagement.enabled')"
      dataType="boolean"
    ></dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="save"></dxi-button>
      <dxi-button name="cancel"></dxi-button>
      <dxi-button name="delete"></dxi-button>
      <dxi-button icon="copy" hint="Duplicate" [onClick]="duplicateRow">
      </dxi-button>
    </dxi-column>
  </dx-data-grid>

  <dx-button
    *ngIf="selectedPublisher"
    icon="add"
    [text]="formatMessage('paperManagement.addNew')"
    type="default"
    stylingMode="contained"
    style="margin-top: 12px"
    (onClick)="addNewRow()"
  ></dx-button>

  <div *ngIf="!selectedPublisher && !isLoading" class="no-publisher-message">
    {{ formatMessage("paperManagement.selectPublisherToView") }}
  </div>

  <dx-load-panel
    [visible]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    shadingColor="rgba(0,0,0,0.4)"
  ></dx-load-panel>
</div>
